import { useEffect } from 'react';
import { PageHead } from '../../components/ui/PageHead';
import { PageHero } from '../../components/hero/PageHero';
import { Section } from '../../components/layout/Section';
import { Container } from '../../components/layout/Container';
import styles from './ContactPage.module.css';

export function ContactPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <PageHead
        title="Contact"
        description="Request a demo, schedule an architecture review, or start a conversation with the NAATS team."
      />

      <PageHero
        eyebrow="Get in Touch"
        title="Let's Talk"
        description="Have a question or want to see the platform in action? We'd love to hear from you."
      />

      <Section bg="page">
        <Container>
          <div className={styles.layout}>
            {/* Left: message */}
            <div className={styles.sidebar}>
              <h2 className={styles.sidebarTitle}>Reach Out</h2>
              <p className={styles.sidebarText}>
                Whether you're evaluating a platform migration, want a live demo, or have a specific
                data or AI challenge - book a time directly with our team and we'll come prepared.
              </p>
              <p className={styles.sidebarText}>
                For architecture inquiries, all inquiries will be routed to najeem.adeleke@naatsgroup.com.
              </p>
            </div>

            {/* Right: Calendly embed */}
            <div className={styles.formPanel}>
              <h2 className={styles.formTitle}>Book a Meeting</h2>
              <div
                className={`calendly-inline-widget ${styles.calendlyWidget}`}
                data-url="https://calendly.com/najeemadeleke"
              />
            </div>
          </div>
        </Container>
      </Section>
    </>
  );
}
